import { computed, effect, Signal, signal } from "@preact/signals";

import { Status, WorkflowResults, WorkflowGroups, Commit, CommitProps, BranchData } from './types';
import { O, A } from "@mobily/ts-belt";

const makeworkflowresults = (n,status): WorkflowResults => {
  const ears = ['pass', 'fail', 'warn'] as const;
  return [...Array(n)].map((_,i) =>
    ({commit: i.toString().padStart(16, '0'), status, ear: ears[i], })
  );
}

const g = (p: Status) => ({
  title: "macos",
  children: makeworkflowresults(10, p),
  subgroups: [],
}) as const;

const grp: WorkflowGroups = {
  title: "main",
  children: [],
  subgroups: [g('pass'), g('fail'), g('warn'), g('running')],
};

const acommit: Commit = {
  hash: '69905810c483811abff5f9971799bc8a32eb4514',
  message: `[msan][NFCI] Add tests for Arm NEON saturating extract narrow (#125331)
Forked from llvm/test/CodeGen/AArch64/arm64-vmovn.ll

Unknown intrinsics which are currently incorrectly handled by
visitInstruction:
- llvm.aarch64.neon.sqxtn
- llvm.aarch64.neon.sqxtun
- llvm.aarch64.neon.uqxtn`,
  author: 'boo boop <boop@example.com>',
  date: new Date('01-02-2000'),
  owner: 'a',
  repo: 'b',
}

export const branchstore: BranchData = {
  commits: signal([]),
  results: signal({}),
};

export const commits = branchstore.commits;

export const commitprops = computed(() => {
  return commits.value.map(x => ({...x, rowspan: 1}));
});

export const workflowgroups = computed(() => {

  const root: WorkflowGroups = {
    title: 'root',
    fullname: 'root',
    subgroups: [],
  };

  function focus(p: string[], g = root) {
    // console.log(p, g);
    if (p.length == 0) return g;

    const p0 = p[0];
    const opt = A.find(g.subgroups, x => x.title === p0);
    let subgroup: WorkflowGroups;
    if (O.isSome(opt)){
      subgroup = O.getExn(opt);
    } else {
      subgroup = {
        title: p0,
        fullname: p0,
        subgroups: [],
      };
      g.subgroups.push(subgroup);
    }
    return focus(p.slice(1), subgroup);
  }

  for (const x of Object.values(branchstore.results.value)) {
    const ress = x.value;
    if (!ress.length) continue;
    const res = ress[0];
    // console.log(res);
    const grp = focus(res.parents);
    grp.fullname = res.fullname;
  }

  // console.log(root.subgroups);
  // console.log(branchstore.results.value);

  return root.subgroups;
});

